import { Controller } from "@hotwired/stimulus"
import TripModalView from "../src/trips/scripts/trip_modal_view"

type OpenModalParams = {
  title?: string
}

export default class extends Controller {
  modalView: TripModalView

  open({ currentTarget, params }: { currentTarget: HTMLAnchorElement | null, params: OpenModalParams }) {
    if (!currentTarget) { return }

    console.log(params)
    const url = currentTarget.href
    const title = params.title || "Confirm"

    // We probably don't need 'Trip Modal' any more pretty soon.
    this.modalView = new TripModalView({
      parentView:       this,
      submitButtonText: title,
      url,
      title,
    })
  }
}
